<div *ngIf="isShowContractWarning" class="flex justify-center">
    <div class="w-full">
        <div class="border border-palette-amber-300 bg-palette-amber-25 !p-[16px] rounded-lg min-h-[93px]">
            <div>
                <span class="font-inter text-lg !leading-5 font-semibold text-palette-gray-900">
                    {{ 'OTA.CONTRACT_AGREEMENT.CONTRACT_WARNING_TITLE'
                    | translate | sentenceCase}}</span>
                <p class="font-inter text-sm font-normal text-palette-gray-700">
                    {{ 'OTA.CONTRACT_AGREEMENT.CONTRACT_WARNING' | translate | sentenceCase}}
                </p>
            </div>
            <div *ngIf="isShowBtnUpdateContract" class="w-full flex justify-end">
                <p (click)="navigateContactPage()"
                    class="text-palette-blue-600 font-medium text-sm cursor-pointer">
                    {{ 'OTA.CONTRACT_AGREEMENT.UPDATE' | translate}}
                    <i class="sctr-icon-arrow-right font-medium text-sm"></i>
                </p>
            </div>
        </div>
    </div>
</div>